export const countries = {
  AL: {
    en: 'Albania',
    fr: 'Albanie',
    prefix: '355',
  },
  DZ: {
    en: 'Algeria',
    fr: 'Algérie',
    prefix: '213',
  },
  AD: {
    en: 'Andorra',
    fr: 'Andorre',
    prefix: '376',
  },
  AT: {
    en: 'Austria',
    fr: 'Autriche',
    prefix: '43',
  },
  BY: {
    en: 'Belarus',
    fr: 'Bélarus',
    prefix: '375',
  },
  BE: {
    en: 'Belgium',
    fr: 'Belgique',
    prefix: '32',
  },
  BA: {
    en: 'Bosnia and Herzegovina',
    fr: 'Bosnie-Herzégovine',
    prefix: '387',
  },
  BG: {
    en: 'Bulgaria',
    fr: 'Bulgarie',
    prefix: '359',
  },
  HR: {
    en: 'Croatia',
    fr: 'Croatie',
    prefix: '385',
  },
  CY: {
    en: 'Cyprus',
    fr: 'Chypre',
    prefix: '357',
  },
  CZ: {
    en: 'Czechia',
    fr: 'Tchéquie',
    prefix: '420',
  },
  DK: {
    en: 'Denmark',
    fr: 'Danemark',
    prefix: '45',
  },
  EG: {
    en: 'Egypt',
    fr: 'Égypte',
    prefix: '20',
  },
  EE: {
    en: 'Estonia',
    fr: 'Estonie',
    prefix: '372',
  },
  FI: {
    en: 'Finland',
    fr: 'Finlande',
    prefix: '358',
  },
  FR: {
    en: 'France',
    fr: 'France',
    prefix: '33',
  },
  DE: {
    en: 'Germany',
    fr: 'Allemagne',
    prefix: '49',
  },
  GR: {
    en: 'Greece',
    fr: 'Grèce',
    prefix: '30',
  },
  HU: {
    en: 'Hungary',
    fr: 'Hongrie',
    prefix: '36',
  },
  IS: {
    en: 'Iceland',
    fr: 'Islande',
    prefix: '354',
  },
  IE: {
    en: 'Ireland',
    fr: 'Irlande',
    prefix: '353',
  },
  IT: {
    en: 'Italy',
    fr: 'Italie',
    prefix: '39',
  },
  LV: {
    en: 'Latvia',
    fr: 'Lettonie',
    prefix: '371',
  },
  LI: {
    en: 'Liechtenstein',
    fr: 'Liechtenstein',
    prefix: '423',
  },
  LT: {
    en: 'Lithuania',
    fr: 'Lituanie',
    prefix: '370',
  },
  LU: {
    en: 'Luxembourg',
    fr: 'Luxembourg',
    prefix: '352',
  },
  MT: {
    en: 'Malta',
    fr: 'Malte',
    prefix: '356',
  },
  MD: {
    en: 'Moldova',
    fr: 'Moldova',
    prefix: '373',
  },
  MC: {
    en: 'Monaco',
    fr: 'Monaco',
    prefix: '377',
  },
  ME: {
    en: 'Montenegro',
    fr: 'Monténégro',
    prefix: '382',
  },
  MA: {
    en: 'Morocco',
    fr: 'Maroc',
    prefix: '212',
  },
  NL: {
    en: 'Netherlands',
    fr: 'Pays-Bas',
    prefix: '31',
  },
  MK: {
    en: 'North Macedonia',
    fr: 'Macédoine du Nord',
    prefix: '389',
  },
  NO: {
    en: 'Norway',
    fr: 'Norvège',
    prefix: '47',
  },
  PL: {
    en: 'Poland',
    fr: 'Pologne',
    prefix: '48',
  },
  PT: {
    en: 'Portugal',
    fr: 'Portugal',
    prefix: '351',
  },
  RO: {
    en: 'Romania',
    fr: 'Roumanie',
    prefix: '40',
  },
  RU: {
    en: 'Russia',
    fr: 'Russie',
    prefix: '7',
  },
  SM: {
    en: 'San Marino',
    fr: 'Saint-Marin',
    prefix: '378',
  },
  RS: {
    en: 'Serbia',
    fr: 'Serbie',
    prefix: '381',
  },
  SK: {
    en: 'Slovakia',
    fr: 'Slovaquie',
    prefix: '421',
  },
  SI: {
    en: 'Slovenia',
    fr: 'Slovénie',
    prefix: '386',
  },
  ES: {
    en: 'Spain',
    fr: 'Espagne',
    prefix: '34',
  },
  SE: {
    en: 'Sweden',
    fr: 'Suède',
    prefix: '46',
  },
  CH: {
    en: 'Switzerland',
    fr: 'Suisse',
    prefix: '41',
  },
  TN: {
    en: 'Tunisia',
    fr: 'Tunisie',
    prefix: '216',
  },
  UA: {
    en: 'Ukraine',
    fr: 'Ukraine',
    prefix: '380',
  },
  GB: {
    en: 'United Kingdom of Great Britain and Northern Ireland',
    fr: 'Royaume-Uni de Grande-Bretagne et d’Irlande du Nord',
    prefix: '44',
  },
};
